import { resolveComponent as _resolveComponent, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, mergeProps as _mergeProps, vShow as _vShow, withDirectives as _withDirectives } from "vue"
import _imports_0 from '../assets/logo.png'


const _hoisted_1 = {
  key: 0,
  class: "mr-2"
}
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = {
  key: 1,
  class: "text--secondary mt-1"
}
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { key: 2 }
const _hoisted_8 = { key: 3 }
const _hoisted_9 = { key: 2 }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { key: 1 }
const _hoisted_12 = ["onClick"]
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { key: 0 }
const _hoisted_15 = { key: 1 }
const _hoisted_16 = { key: 2 }
const _hoisted_17 = { key: 3 }
const _hoisted_18 = { key: 1 }
const _hoisted_19 = { key: 0 }
const _hoisted_20 = { key: 1 }
const _hoisted_21 = { key: 0 }
const _hoisted_22 = { key: 0 }
const _hoisted_23 = ["colspan"]
const _hoisted_24 = { class: "d-flex pt-3" }
const _hoisted_25 = ["onClick"]
const _hoisted_26 = ["onClick"]
const _hoisted_27 = ["onClick"]
const _hoisted_28 = ["onClick"]
const _hoisted_29 = ["colspan"]
const _hoisted_30 = { class: "text-center" }
const _hoisted_31 = { class: "text-center" }
const _hoisted_32 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn_back = _resolveComponent("v-btn-back")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_btn_prev = _resolveComponent("v-btn-prev")!
  const _component_v_btn_icon = _resolveComponent("v-btn-icon")!
  const _component_v_btn_next = _resolveComponent("v-btn-next")!
  const _component_v_data_table = _resolveComponent("v-data-table")!
  const _component_ReconciliationWizard = _resolveComponent("ReconciliationWizard")!
  const _component_v_toolbar_title = _resolveComponent("v-toolbar-title")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_toolbar = _resolveComponent("v-toolbar")!
  const _component_oss_text_field = _resolveComponent("oss-text-field")!
  const _component_v_flex = _resolveComponent("v-flex")!
  const _component_oss_date_range_picker = _resolveComponent("oss-date-range-picker")!
  const _component_v_text_field_filled = _resolveComponent("v-text-field-filled")!
  const _component_v_layout = _resolveComponent("v-layout")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_data_table_server = _resolveComponent("v-data-table-server")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_Chat = _resolveComponent("Chat")!

  return (_openBlock(), _createBlock(_component_v_container, { fluid: "" }, {
    default: _withCtx(() => [
      _createVNode(_component_v_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, {
            sm: "9",
            cols: "12",
            class: "d-flex"
          }, {
            default: _withCtx(() => [
              (_ctx.$vuetify.display.smAndUp)
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                    (_ctx.mode != 'GeneralLedger')
                      ? (_openBlock(), _createBlock(_component_v_btn_back, {
                          key: 0,
                          onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.back()), ["stop"]))
                        }))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", null, [
                (!_ctx.$vuetify.display.mobile)
                  ? (_openBlock(), _createElementBlock("h1", _hoisted_2, _toDisplayString(_ctx.clientTitle), 1))
                  : (_openBlock(), _createElementBlock("h2", _hoisted_3, _toDisplayString(_ctx.clientTitle), 1))
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_row, null, {
        default: _withCtx(() => [
          (_ctx.$vuetify.display.mobile)
            ? (_openBlock(), _createBlock(_component_v_col, {
                key: 0,
                cols: "12"
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.groupedAccountingLines, (al) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: al.id,
                      class: "default_card_wm pa-2 mb-3"
                    }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(al.items, (ai, aiIndex) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: al.id + '.' + ai.id
                        }, [
                          _createVNode(_component_v_row, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_col, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_icon, {
                                    size: "small",
                                    location: "start"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(ai.iconType), 1)
                                    ]),
                                    _: 2
                                  }, 1024),
                                  (
                                        (ai.bt && ai.bt.accountingItemImport) ||
                                        (ai.doc && ai.doc.accountingItemImport)
                                    )
                                    ? (_openBlock(), _createBlock(_component_v_chip, {
                                        key: 0,
                                        label: "",
                                        color: "grey",
                                        class: "mr-2",
                                        size: "small",
                                        variant: "outlined"
                                      }, {
                                        default: _withCtx(() => _cache[28] || (_cache[28] = [
                                          _createTextVNode("Importé")
                                        ])),
                                        _: 1
                                      }))
                                    : _createCommentVNode("", true),
                                  _createTextVNode(" " + _toDisplayString(ai.name) + " ", 1),
                                  (ai.bt)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                                        (ai.suppliers)
                                          ? (_openBlock(), _createElementBlock("span", _hoisted_5, "Fournisseur: " + _toDisplayString(ai.suppliers), 1))
                                          : _createCommentVNode("", true),
                                        (ai.customers)
                                          ? (_openBlock(), _createElementBlock("span", _hoisted_6, "Client: " + _toDisplayString(ai.customers), 1))
                                          : _createCommentVNode("", true),
                                        (ai.user)
                                          ? (_openBlock(), _createElementBlock("span", _hoisted_7, "Collaborateur : " + _toDisplayString(ai.user), 1))
                                          : _createCommentVNode("", true),
                                        (ai.bankAccount)
                                          ? (_openBlock(), _createElementBlock("span", _hoisted_8, "Compte bancaire : " + _toDisplayString(ai.bankAccount), 1))
                                          : _createCommentVNode("", true)
                                      ]))
                                    : _createCommentVNode("", true),
                                  (ai.doc)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                                        (ai.doc.type === 'WITHOUT_INVOICE')
                                          ? (_openBlock(), _createElementBlock("span", _hoisted_10, "Sans justificatif"))
                                          : (ai.doc.type === 'SALES_INVOICE_AUTO')
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_11, "Encaissemment"))
                                            : _createCommentVNode("", true)
                                      ]))
                                    : _createCommentVNode("", true)
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_component_v_divider, { class: "mt-3 mb-2" }),
                          _createVNode(_component_v_row, { class: "d-flex" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_col, { class: "d-flex align-center" }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.formatDate(ai.date)), 1)
                                ]),
                                _: 2
                              }, 1024),
                              (aiIndex === 0 && _ctx.groupStatusWithoutAA(al))
                                ? (_openBlock(), _createBlock(_component_v_col, {
                                    key: 0,
                                    class: "d-flex align-center flex-shrink-1 flex-grow-0"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_chip, {
                                        label: "",
                                        size: "small",
                                        variant: "outlined"
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(_ctx.groupStatusWithoutAA(al)), 1)
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ]),
                                    _: 2
                                  }, 1024))
                                : _createCommentVNode("", true),
                              _createVNode(_component_v_col, { class: "d-flex align-center justify-end flex-grow-1 flex-shrink-0" }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(ai.debit
                                        ? `Debit: ${_ctx.newCommonFormatCurrency(ai.debit, undefined)}`
                                        : "") + " " + _toDisplayString(ai.credit
                                        ? `Credit: ${_ctx.newCommonFormatCurrency(ai.credit, undefined)}`
                                        : ""), 1)
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1024)
                        ]))
                      }), 128))
                    ]))
                  }), 128))
                ]),
                _: 1
              }))
            : (_openBlock(), _createBlock(_component_v_col, { key: 1 }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_data_table, {
                    headers: _ctx.groupItemsHeaders2,
                    items: _ctx.groupedAccountingLines,
                    "hide-default-footer": "",
                    "items-per-page": -1,
                    class: "table",
                    "fixed-header": "",
                    "max-height": "60vh",
                    loading: _ctx.loading,
                    style: {"width":"100%"},
                    xs12: ""
                  }, {
                    item: _withCtx(({ item, index }) => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.items, (accountingItem, alIndex) => {
                        return (_openBlock(), _createElementBlock("tr", {
                          style: _normalizeStyle(
                                alIndex === 0
                                    ? 'cursor: pointer; border-top;font-weight: bold;'
                                    : 'cursor: pointer'
                            ),
                          key: index + '-' + alIndex,
                          onClick: _withModifiers(($event: any) => (_ctx.addRemoveReconciliationExpend(accountingItem)), ["stop"])
                        }, [
                          _createElementVNode("td", {
                            class: "text-center",
                            style: _normalizeStyle(_ctx.getCellStyle(alIndex, false))
                          }, [
                            _createVNode(_component_v_icon, {
                              small: true,
                              class: "mr-2"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(accountingItem.iconType), 1)
                              ]),
                              _: 2
                            }, 1024)
                          ], 4),
                          _createElementVNode("td", {
                            class: "text-left",
                            style: _normalizeStyle(_ctx.getCellStyle(alIndex, false))
                          }, [
                            _createElementVNode("div", null, [
                              (
                                            (accountingItem.bt &&
                                                accountingItem.bt.accountingItemImport) ||
                                            (accountingItem.doc &&
                                                accountingItem.doc.accountingItemImport)
                                        )
                                ? (_openBlock(), _createBlock(_component_v_chip, {
                                    key: 0,
                                    label: "",
                                    color: "grey",
                                    class: "mr-2",
                                    size: "small",
                                    variant: "outlined"
                                  }, {
                                    default: _withCtx(() => _cache[29] || (_cache[29] = [
                                      _createTextVNode("Importé")
                                    ])),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true),
                              _createTextVNode(_toDisplayString(accountingItem.name), 1)
                            ]),
                            (accountingItem.bt)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                                  (accountingItem.suppliers)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_14, "Fournisseur: " + _toDisplayString(accountingItem.suppliers), 1))
                                    : _createCommentVNode("", true),
                                  (accountingItem.customers)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_15, "Client: " + _toDisplayString(accountingItem.customers), 1))
                                    : _createCommentVNode("", true),
                                  (accountingItem.user)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_16, "Collaborateur : " + _toDisplayString(accountingItem.user), 1))
                                    : _createCommentVNode("", true),
                                  (accountingItem.bankAccount)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_17, "Compte bancaire : " + _toDisplayString(accountingItem.bankAccount), 1))
                                    : _createCommentVNode("", true)
                                ]))
                              : _createCommentVNode("", true),
                            (accountingItem.doc)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                                  (accountingItem.doc.type === 'WITHOUT_INVOICE')
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_19, "Sans justificatif"))
                                    : (accountingItem.doc.type === 'SALES_INVOICE_AUTO')
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_20, "Encaissemment"))
                                      : _createCommentVNode("", true)
                                ]))
                              : _createCommentVNode("", true)
                          ], 4),
                          _createElementVNode("td", {
                            class: "text-center",
                            style: _normalizeStyle(_ctx.getCellStyle(alIndex, false))
                          }, _toDisplayString(accountingItem.date), 5),
                          _createElementVNode("td", {
                            class: "text-right",
                            style: _normalizeStyle(_ctx.getCellStyle(alIndex, false))
                          }, [
                            (_ctx.isMainItem(item, accountingItem))
                              ? (_openBlock(), _createElementBlock("span", _hoisted_21, _toDisplayString(accountingItem.debit
                                        ? _ctx.newCommonFormatCurrency(accountingItem.debit, undefined)
                                        : "-"), 1))
                              : _createCommentVNode("", true)
                          ], 4),
                          _createElementVNode("td", {
                            class: "text-right",
                            style: _normalizeStyle(_ctx.getCellStyle(alIndex, false))
                          }, [
                            (_ctx.isMainItem(item, accountingItem))
                              ? (_openBlock(), _createElementBlock("span", _hoisted_22, _toDisplayString(accountingItem.credit
                                        ? _ctx.newCommonFormatCurrency(accountingItem.credit, undefined)
                                        : "-"), 1))
                              : _createCommentVNode("", true)
                          ], 4),
                          (_ctx.isAccountingUser)
                            ? (_openBlock(), _createElementBlock("td", {
                                key: 0,
                                class: "text-center",
                                style: _normalizeStyle(_ctx.getCellStyle(alIndex, false))
                              }, [
                                _createElementVNode("span", {
                                  style: _normalizeStyle(_ctx.getIfNecessaryAccountableAccountColor(item, alIndex))
                                }, _toDisplayString(_ctx.getIfNecessaryAccountableAccount(item, alIndex)), 5)
                              ], 4))
                            : _createCommentVNode("", true),
                          _createElementVNode("td", {
                            class: "text-center",
                            style: _normalizeStyle(_ctx.getCellStyle(alIndex, false))
                          }, [
                            (alIndex === 0 && _ctx.groupStatusWithoutAA(item))
                              ? (_openBlock(), _createBlock(_component_v_chip, {
                                  key: 0,
                                  class: "ma-2 font-weight-regular",
                                  label: "",
                                  size: "small",
                                  variant: "outlined"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.groupStatusWithoutAA(item)), 1)
                                  ]),
                                  _: 2
                                }, 1024))
                              : _createCommentVNode("", true)
                          ], 4),
                          (_ctx.isAccountingUser)
                            ? (_openBlock(), _createElementBlock("td", {
                                key: 1,
                                class: "text-center",
                                style: _normalizeStyle(_ctx.getCellStyle(alIndex, true))
                              }, [
                                _createVNode(_component_v_list, {
                                  rounded: "",
                                  class: "ma-2",
                                  density: "compact"
                                }, {
                                  default: _withCtx(() => [
                                    (_ctx.needsAction(item))
                                      ? (_openBlock(), _createBlock(_component_v_list_item, {
                                          key: 0,
                                          onClick: _withModifiers(($event: any) => (_ctx.activateActionMenu($event, item)), ["stop"])
                                        }, {
                                          append: _withCtx(() => [
                                            _createVNode(_component_v_icon, { size: "x-small" }, {
                                              default: _withCtx(() => _cache[31] || (_cache[31] = [
                                                _createTextVNode("$dots_vertical")
                                              ])),
                                              _: 1
                                            })
                                          ]),
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_list_item_title, null, {
                                              default: _withCtx(() => _cache[30] || (_cache[30] = [
                                                _createTextVNode("Plus d'actions")
                                              ])),
                                              _: 1
                                            })
                                          ]),
                                          _: 2
                                        }, 1032, ["onClick"]))
                                      : _createCommentVNode("", true),
                                    (_ctx.containsDocumentToValidate(item))
                                      ? (_openBlock(), _createBlock(_component_v_list_item, {
                                          key: 1,
                                          onClick: _withModifiers(($event: any) => (
                                            _ctx.addRemoveReconciliationExpend(
                                                _ctx.containsDocumentToValidate(item),
                                            )
                                        ), ["stop"])
                                        }, {
                                          append: _withCtx(() => [
                                            _createVNode(_component_v_icon, { size: "x-small" }, {
                                              default: _withCtx(() => _cache[33] || (_cache[33] = [
                                                _createTextVNode("$fa-thumbs-up")
                                              ])),
                                              _: 1
                                            })
                                          ]),
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_list_item_title, null, {
                                              default: _withCtx(() => _cache[32] || (_cache[32] = [
                                                _createTextVNode("Valider le document")
                                              ])),
                                              _: 1
                                            })
                                          ]),
                                          _: 2
                                        }, 1032, ["onClick"]))
                                      : (accountingItem.doc)
                                        ? (_openBlock(), _createBlock(_component_v_list_item, {
                                            key: 2,
                                            onClick: _withModifiers(($event: any) => (_ctx.addRemoveReconciliationExpend(accountingItem)), ["stop"])
                                          }, {
                                            append: _withCtx(() => [
                                              _createVNode(_component_v_icon, { size: "x-small" }, {
                                                default: _withCtx(() => _cache[35] || (_cache[35] = [
                                                  _createTextVNode("$fa-eye")
                                                ])),
                                                _: 1
                                              })
                                            ]),
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_list_item_title, null, {
                                                default: _withCtx(() => _cache[34] || (_cache[34] = [
                                                  _createTextVNode("Afficher le document")
                                                ])),
                                                _: 1
                                              })
                                            ]),
                                            _: 2
                                          }, 1032, ["onClick"]))
                                        : _createCommentVNode("", true),
                                    (alIndex === 0)
                                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                                          (
                                                !_ctx.containsDocumentToValidate(item) &&
                                                _ctx.showValidateReconciliation(item)
                                            )
                                            ? (_openBlock(), _createBlock(_component_v_list_item, {
                                                key: 0,
                                                onClick: _withModifiers(($event: any) => (_ctx.validateReconciliation(item)), ["stop"]),
                                                loading: _ctx.actionLoading
                                              }, {
                                                append: _withCtx(() => [
                                                  _createVNode(_component_v_icon, { size: "x-small" }, {
                                                    default: _withCtx(() => _cache[36] || (_cache[36] = [
                                                      _createTextVNode("$fa-thumbs-up")
                                                    ])),
                                                    _: 1
                                                  })
                                                ]),
                                                default: _withCtx(() => [
                                                  _createVNode(_component_v_list_item_title, null, {
                                                    default: _withCtx(() => [
                                                      _createTextVNode("Valider le lettrage" + _toDisplayString(_ctx.getReconciliationValidationType(item) ===
                                                    "PENDING_VALIDATION_FROM_CLIENT"
                                                        ? " client"
                                                        : "") + " auto", 1)
                                                    ]),
                                                    _: 2
                                                  }, 1024)
                                                ]),
                                                _: 2
                                              }, 1032, ["onClick", "loading"]))
                                            : _createCommentVNode("", true),
                                          (
                                                !_ctx.containsDocumentToValidate(item) &&
                                                _ctx.showValidateReconciliation(item)
                                            )
                                            ? (_openBlock(), _createBlock(_component_v_list_item, {
                                                key: 1,
                                                onClick: _withModifiers(($event: any) => (_ctx.deleteReconciliation(item)), ["stop"]),
                                                loading: _ctx.actionLoading
                                              }, {
                                                append: _withCtx(() => [
                                                  _createVNode(_component_v_icon, { size: "x-small" }, {
                                                    default: _withCtx(() => _cache[37] || (_cache[37] = [
                                                      _createTextVNode("$fa-thumbs-down")
                                                    ])),
                                                    _: 1
                                                  })
                                                ]),
                                                default: _withCtx(() => [
                                                  _createVNode(_component_v_list_item_title, null, {
                                                    default: _withCtx(() => [
                                                      _createTextVNode("Refuser le lettrage" + _toDisplayString(_ctx.getReconciliationValidationType(item) ===
                                                    "PENDING_VALIDATION_FROM_CLIENT"
                                                        ? "client "
                                                        : "") + " auto", 1)
                                                    ]),
                                                    _: 2
                                                  }, 1024)
                                                ]),
                                                _: 2
                                              }, 1032, ["onClick", "loading"]))
                                            : (_ctx.showRemoveCashbox(item))
                                              ? (_openBlock(), _createBlock(_component_v_list_item, {
                                                  key: 2,
                                                  onClick: _withModifiers(($event: any) => (_ctx.removeCashbox(item)), ["stop"]),
                                                  loading: _ctx.actionLoading
                                                }, {
                                                  append: _withCtx(() => [
                                                    _createVNode(_component_v_icon, { size: "x-small" }, {
                                                      default: _withCtx(() => _cache[39] || (_cache[39] = [
                                                        _createTextVNode("$fa-trash-alt")
                                                      ])),
                                                      _: 1
                                                    })
                                                  ]),
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_v_list_item_title, null, {
                                                      default: _withCtx(() => _cache[38] || (_cache[38] = [
                                                        _createTextVNode("Retirer de la caisse")
                                                      ])),
                                                      _: 1
                                                    })
                                                  ]),
                                                  _: 2
                                                }, 1032, ["onClick", "loading"]))
                                              : (_ctx.showRemoveRemittance(item))
                                                ? (_openBlock(), _createBlock(_component_v_list_item, {
                                                    key: 3,
                                                    onClick: _withModifiers(($event: any) => (_ctx.deleteReconciliation(item)), ["stop"]),
                                                    loading: _ctx.actionLoading
                                                  }, {
                                                    append: _withCtx(() => [
                                                      _createVNode(_component_v_icon, { size: "x-small" }, {
                                                        default: _withCtx(() => _cache[41] || (_cache[41] = [
                                                          _createTextVNode("$fa-trash-alt")
                                                        ])),
                                                        _: 1
                                                      })
                                                    ]),
                                                    default: _withCtx(() => [
                                                      _createVNode(_component_v_list_item_title, null, {
                                                        default: _withCtx(() => _cache[40] || (_cache[40] = [
                                                          _createTextVNode("Retirer du paiement par chèque")
                                                        ])),
                                                        _: 1
                                                      })
                                                    ]),
                                                    _: 2
                                                  }, 1032, ["onClick", "loading"]))
                                                : (_ctx.showRemoveCurrentAccount(item))
                                                  ? (_openBlock(), _createBlock(_component_v_list_item, {
                                                      key: 4,
                                                      onClick: _withModifiers(($event: any) => (_ctx.removeCurrentAccount(item)), ["stop"])
                                                    }, {
                                                      append: _withCtx(() => [
                                                        _createVNode(_component_v_icon, { size: "x-small" }, {
                                                          default: _withCtx(() => _cache[42] || (_cache[42] = [
                                                            _createTextVNode("$fa-trash-alt")
                                                          ])),
                                                          _: 1
                                                        })
                                                      ]),
                                                      default: _withCtx(() => [
                                                        _createVNode(_component_v_list_item_title, null, {
                                                          default: _withCtx(() => [
                                                            _createTextVNode(_toDisplayString(_ctx.removeCurrentAccountTitle), 1)
                                                          ]),
                                                          _: 1
                                                        })
                                                      ]),
                                                      _: 2
                                                    }, 1032, ["onClick"]))
                                                  : (_ctx.showDeleteReconciliation(item))
                                                    ? (_openBlock(), _createBlock(_component_v_list_item, {
                                                        key: 5,
                                                        onClick: _withModifiers(($event: any) => (_ctx.deleteReconciliation(item)), ["stop"])
                                                      }, {
                                                        append: _withCtx(() => [
                                                          _createVNode(_component_v_icon, { size: "x-small" }, {
                                                            default: _withCtx(() => _cache[44] || (_cache[44] = [
                                                              _createTextVNode("$fa-trash-alt")
                                                            ])),
                                                            _: 1
                                                          })
                                                        ]),
                                                        default: _withCtx(() => [
                                                          _createVNode(_component_v_list_item_title, null, {
                                                            default: _withCtx(() => _cache[43] || (_cache[43] = [
                                                              _createTextVNode("Supprimer le lettrage")
                                                            ])),
                                                            _: 1
                                                          })
                                                        ]),
                                                        _: 2
                                                      }, 1032, ["onClick"]))
                                                    : (
                                                _ctx.showGroupNotReconciliatedAndWithImputation(item) &&
                                                _ctx.enableRemoveImputation(item)
                                            )
                                                      ? (_openBlock(), _createBlock(_component_v_list_item, {
                                                          key: 6,
                                                          onClick: _withModifiers(($event: any) => (_ctx.removeImputation(item)), ["stop"])
                                                        }, {
                                                          append: _withCtx(() => [
                                                            _createVNode(_component_v_icon, { size: "x-small" }, {
                                                              default: _withCtx(() => _cache[45] || (_cache[45] = [
                                                                _createTextVNode("$fa-trash-alt")
                                                              ])),
                                                              _: 1
                                                            })
                                                          ]),
                                                          default: _withCtx(() => [
                                                            _createVNode(_component_v_list_item_title, null, {
                                                              default: _withCtx(() => [
                                                                _createTextVNode(_toDisplayString(_ctx.removeImputationTitle(item)), 1)
                                                              ]),
                                                              _: 2
                                                            }, 1024)
                                                          ]),
                                                          _: 2
                                                        }, 1032, ["onClick"]))
                                                      : _createCommentVNode("", true),
                                          (_ctx.enableShowGeneralLedger(item))
                                            ? (_openBlock(), _createBlock(_component_v_list_item, {
                                                key: 7,
                                                onClick: _withModifiers(($event: any) => (_ctx.showGeneralLedger(item)), ["stop"])
                                              }, {
                                                append: _withCtx(() => [
                                                  _createVNode(_component_v_icon, { size: "x-small" }, {
                                                    default: _withCtx(() => _cache[47] || (_cache[47] = [
                                                      _createTextVNode("$fa-chevron-right")
                                                    ])),
                                                    _: 1
                                                  })
                                                ]),
                                                default: _withCtx(() => [
                                                  _createVNode(_component_v_list_item_title, null, {
                                                    default: _withCtx(() => _cache[46] || (_cache[46] = [
                                                      _createTextVNode("Grand Livre")
                                                    ])),
                                                    _: 1
                                                  })
                                                ]),
                                                _: 2
                                              }, 1032, ["onClick"]))
                                            : _createCommentVNode("", true)
                                        ], 64))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _: 2
                                }, 1024)
                              ], 4))
                            : _createCommentVNode("", true)
                        ], 12, _hoisted_12))
                      }), 128))
                    ]),
                    "body.append": _withCtx(() => [
                      _createElementVNode("tr", null, [
                        _createElementVNode("td", {
                          colspan: _ctx.isAccountingUser ? 7 : 5,
                          style: _normalizeStyle(_ctx.getCellStyle(0, false))
                        }, null, 12, _hoisted_23),
                        (
                                    _ctx.selectedCompany.solution !== 'MANAGEMENT' &&
                                    _ctx.mode != 'GeneralLedger'
                                )
                          ? (_openBlock(), _createElementBlock("td", {
                              key: 0,
                              class: "d-flex align-center justify-end",
                              style: _normalizeStyle(_ctx.getCellStyle(0, false))
                            }, [
                              _createVNode(_component_v_tooltip, { location: "top" }, {
                                activator: _withCtx(({ props }) => [
                                  (!_ctx.reconciliation || !_ctx.reconciliation.id)
                                    ? (_openBlock(), _createBlock(_component_v_btn, _mergeProps({
                                        key: 0,
                                        rounded: "circle",
                                        elevation: "0",
                                        class: "mr-2",
                                        onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.setOpenChat('INFORMATION_REQUEST')), ["stop"])),
                                        size: "x-small"
                                      }, props, { icon: "$oss-chat" }), null, 16))
                                    : _createCommentVNode("", true)
                                ]),
                                default: _withCtx(() => [
                                  _cache[48] || (_cache[48] = _createElementVNode("span", null, "Question", -1))
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_tooltip, { location: "top" }, {
                                activator: _withCtx(({ props }) => [
                                  _createVNode(_component_v_btn_prev, _mergeProps({
                                    disabled: _ctx.previousDisabled(),
                                    onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.previous()), ["stop"]))
                                  }, props), null, 16, ["disabled"])
                                ]),
                                default: _withCtx(() => [
                                  _cache[49] || (_cache[49] = _createElementVNode("span", null, "Précédent", -1))
                                ]),
                                _: 1
                              }),
                              (_ctx.toBeDoneStatus)
                                ? (_openBlock(), _createBlock(_component_v_btn_icon, {
                                    key: 0,
                                    icon: "$stop",
                                    size: "small",
                                    elevation: "0",
                                    color: "secondary",
                                    onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.back()), ["stop"]))
                                  }))
                                : _createCommentVNode("", true),
                              _createVNode(_component_v_tooltip, { location: "top" }, {
                                activator: _withCtx(({ props }) => [
                                  (_ctx.mode != 'GeneralLedger')
                                    ? (_openBlock(), _createBlock(_component_v_btn_next, _mergeProps({
                                        key: 0,
                                        disabled: _ctx.nextDisabled(),
                                        onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_ctx.next()), ["stop"]))
                                      }, props), null, 16, ["disabled"]))
                                    : _createCommentVNode("", true)
                                ]),
                                default: _withCtx(() => [
                                  _cache[50] || (_cache[50] = _createElementVNode("span", null, "Suivant", -1))
                                ]),
                                _: 1
                              })
                            ], 4))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _: 1
                  }, 8, ["headers", "items", "loading"])
                ]),
                _: 1
              }))
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_24, [
        (_ctx.editable)
          ? _withDirectives((_openBlock(), _createBlock(_component_ReconciliationWizard, {
              key: 0,
              reconciliationVue: _ctx.reconciliationVue,
              onNewDocument: _ctx.onNewDocument
            }, null, 8, ["reconciliationVue", "onNewDocument"])), [
              [_vShow, !_ctx.documentPanel && !_ctx.bankTransactionPanel]
            ])
          : _createCommentVNode("", true)
      ]),
      _withDirectives(_createVNode(_component_v_card, { class: "default_card_management" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_toolbar, {
            color: "primary",
            class: "elevation-0",
            style: {"border-top-left-radius":"20px !important","border-top-right-radius":"20px !important"}
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_toolbar_title, null, {
                default: _withCtx(() => _cache[51] || (_cache[51] = [
                  _createTextVNode("Choisissez un justificatif")
                ])),
                _: 1
              }),
              _createVNode(_component_v_spacer),
              _createVNode(_component_v_btn_icon, {
                icon: "$close",
                onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.documentPanel = false)),
                style: {"margin":"0"}
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_card_text, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_container, { fluid: "" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_layout, {
                    xs12: "",
                    "align-center": "",
                    class: "filter-layout",
                    id: "documents-filter-box"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_flex, {
                        xs2: "",
                        "ml-2": ""
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_oss_text_field, {
                            outlined: "",
                            modelValue: _ctx.docFilter.amount.minimum,
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.docFilter.amount.minimum) = $event)),
                            label: "Min"
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_flex, {
                        xs2: "",
                        "ml-2": ""
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_oss_text_field, {
                            outlined: "",
                            modelValue: _ctx.docFilter.amount.maximum,
                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.docFilter.amount.maximum) = $event)),
                            label: "Max"
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_flex, {
                        xs4: "",
                        "ml-2": ""
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_oss_date_range_picker, {
                            begin: _ctx.docFilter.date.begin,
                            end: _ctx.docFilter.date.end,
                            onChangeDateRange: _ctx.onDocDateRangeChanged
                          }, null, 8, ["begin", "end", "onChangeDateRange"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_flex, {
                        xs4: "",
                        "ml-2": ""
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_text_field_filled, {
                            outlined: "",
                            modelValue: _ctx.docFilter.search,
                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.docFilter.search) = $event)),
                            "append-inner-icon": "$search",
                            label: "Recherche"
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_flex, {
                        xs1: "",
                        "ml-2": ""
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_btn, {
                            fab: "",
                            size: "x-small",
                            "elevation-0": "",
                            color: "primary",
                            class: "btn",
                            disabled: _ctx.isFiltered(_ctx.defaultDocFilter, _ctx.docFilter),
                            onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.clearDocFilters())),
                            icon: "$clear"
                          }, null, 8, ["disabled"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_container, { fluid: "" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_data_table_server, {
                    headers: _ctx.selectionHeaders,
                    items: _ctx.accountingLines,
                    expanded: _ctx.documentExpanded,
                    "onUpdate:expanded": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.documentExpanded) = $event)),
                    page: _ctx.docFilter.pagination.page,
                    "onUpdate:page": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.docFilter.pagination.page) = $event)),
                    "sort-by": _ctx.docFilter.pagination.sortBy,
                    "onUpdate:sortBy": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.docFilter.pagination.sortBy) = $event)),
                    "sort-desc": _ctx.docFilter.pagination.descending,
                    "onUpdate:sortDesc": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.docFilter.pagination.descending) = $event)),
                    "items-per-page": _ctx.docFilter.pagination.rowsPerPage,
                    "onUpdate:itemsPerPage": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.docFilter.pagination.rowsPerPage) = $event)),
                    "items-length": _ctx.docFilter.pagination.totalItems,
                    "items-per-page-options": [5, 10, 25],
                    class: "table",
                    "fixed-header": "",
                    "max-height": "60vh"
                  }, {
                    item: _withCtx((props) => [
                      _createElementVNode("tr", null, [
                        _createElementVNode("td", {
                          class: "text-center",
                          onClick: ($event: any) => (_ctx.addRemoveDocumentExpand(props.item))
                        }, _toDisplayString(props.item.name), 9, _hoisted_25),
                        _createElementVNode("td", {
                          class: "text-center",
                          onClick: ($event: any) => (_ctx.addRemoveDocumentExpand(props.item))
                        }, _toDisplayString(props.item.date), 9, _hoisted_26),
                        _createElementVNode("td", {
                          class: "text-center",
                          onClick: ($event: any) => (_ctx.addRemoveDocumentExpand(props.item)),
                          style: _normalizeStyle(props.item.amountSigned < 0 ? 'color:red;' : '')
                        }, _toDisplayString(_ctx.newCommonFormatCurrency(props.item.amountSigned, undefined)), 13, _hoisted_27),
                        _createElementVNode("td", {
                          onClick: ($event: any) => {
                                        props.item.selected = !props.item.selected;
                                        _ctx.onSelectItemChanged(props.item);
                                        _ctx.documentPanel = false;
                                    }
                        }, [
                          _createVNode(_component_v_btn, {
                            rounded: "",
                            size: "x-small"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(props.item.selected ? "Retirer" : "Ajouter"), 1)
                            ]),
                            _: 2
                          }, 1024)
                        ], 8, _hoisted_28)
                      ])
                    ]),
                    "expanded-row": _withCtx(({ columns, item }) => [
                      _createElementVNode("td", {
                        colspan: columns.length
                      }, [
                        (item.signedUrl)
                          ? (_openBlock(), _createBlock(_component_v_row, {
                              key: 0,
                              align: "center",
                              justify: "center"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_img, {
                                  src: item.signedUrl,
                                  "lazy-src": _imports_0,
                                  width: "60vw",
                                  contain: true,
                                  class: "elevation-5 ma-4"
                                }, null, 8, ["src"])
                              ]),
                              _: 2
                            }, 1024))
                          : _createCommentVNode("", true)
                      ], 8, _hoisted_29)
                    ]),
                    _: 1
                  }, 8, ["headers", "items", "expanded", "page", "sort-by", "sort-desc", "items-per-page", "items-length"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_card_actions, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_btn, {
                rounded: "",
                onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.documentPanel = false)),
                size: "small"
              }, {
                default: _withCtx(() => _cache[52] || (_cache[52] = [
                  _createTextVNode(" Précédent ")
                ])),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 512), [
        [_vShow, _ctx.documentPanel]
      ]),
      _withDirectives(_createVNode(_component_v_card, { class: "default_card_management" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_toolbar, {
            color: "ternary",
            class: "elevation-0",
            style: {"border-top-left-radius":"20px !important","border-top-right-radius":"20px !important"}
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_toolbar_title, null, {
                default: _withCtx(() => _cache[53] || (_cache[53] = [
                  _createTextVNode("Choisissez un mouvement bancaire")
                ])),
                _: 1
              }),
              _createVNode(_component_v_spacer),
              _createVNode(_component_v_btn_icon, {
                icon: "$close",
                onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.bankTransactionPanel = false)),
                style: {"margin":"0"}
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_card_text, {
            row: "",
            xs12: "",
            wrap: ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_container, { fluid: "" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_layout, {
                    "align-center": "",
                    class: "filter-layout",
                    id: "documents-btFilter-box"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_flex, {
                        xs2: "",
                        "ml-2": ""
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_oss_text_field, {
                            outlined: "",
                            modelValue: _ctx.btFilter.amount.minimum,
                            "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.btFilter.amount.minimum) = $event)),
                            label: "Min"
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_flex, {
                        xs2: "",
                        "ml-2": ""
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_oss_text_field, {
                            outlined: "",
                            modelValue: _ctx.btFilter.amount.maximum,
                            "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.btFilter.amount.maximum) = $event)),
                            label: "Max"
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_flex, {
                        xs4: "",
                        "ml-2": ""
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_oss_date_range_picker, {
                            begin: _ctx.btFilter.date.begin,
                            end: _ctx.btFilter.date.end,
                            onChangeDateRange: _ctx.onBTDateRangeChanged
                          }, null, 8, ["begin", "end", "onChangeDateRange"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_flex, {
                        xs3: "",
                        "ml-2": ""
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_text_field_filled, {
                            outlined: "",
                            modelValue: _ctx.btFilter.search,
                            "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.btFilter.search) = $event)),
                            "append-inner-icon": "$search",
                            label: "Recherche"
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_flex, { "ml-2": "" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_btn, {
                            fab: "",
                            size: "x-small",
                            color: "primary",
                            disabled: _ctx.isFiltered(_ctx.defaultBTFilter, _ctx.btFilter),
                            onClick: _cache[20] || (_cache[20] = ($event: any) => (_ctx.clearBTFilters())),
                            icon: "$clear"
                          }, null, 8, ["disabled"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_container, { fuild: "" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_data_table_server, {
                    headers: _ctx.selectionHeaders,
                    items: _ctx.availableBankTransactions,
                    page: _ctx.btFilter.pagination.page,
                    "onUpdate:page": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.btFilter.pagination.page) = $event)),
                    "sort-by": _ctx.btFilter.pagination.sortBy,
                    "onUpdate:sortBy": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.btFilter.pagination.sortBy) = $event)),
                    "sort-desc": _ctx.btFilter.pagination.descending,
                    "onUpdate:sortDesc": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.btFilter.pagination.descending) = $event)),
                    "items-per-page": _ctx.btFilter.pagination.rowsPerPage,
                    "onUpdate:itemsPerPage": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.btFilter.pagination.rowsPerPage) = $event)),
                    "items-length": _ctx.btFilter.pagination.totalItems,
                    "items-per-page-options": [5, 10, 25],
                    class: "table",
                    "fixed-header": "",
                    "max-height": "60vh"
                  }, {
                    "no-data": _withCtx(() => [
                      _createVNode(_component_v_alert, {
                        color: "error",
                        icon: "warning",
                        "model-value": true
                      }, {
                        default: _withCtx(() => _cache[54] || (_cache[54] = [
                          _createTextVNode("no item")
                        ])),
                        _: 1
                      })
                    ]),
                    item: _withCtx((props) => [
                      _createElementVNode("tr", null, [
                        _createElementVNode("td", _hoisted_30, _toDisplayString(props.item.name), 1),
                        _createElementVNode("td", _hoisted_31, _toDisplayString(props.item.date), 1),
                        _createElementVNode("td", {
                          class: "text-center",
                          style: _normalizeStyle(props.item.amountSigned < 0 ? 'color:red;' : '')
                        }, _toDisplayString(_ctx.newCommonFormatCurrency(props.item.amountSigned, undefined)), 5),
                        _createElementVNode("td", {
                          onClick: ($event: any) => {
                                        props.item.selected = !props.item.selected;
                                        _ctx.onSelectItemChanged(props.item);
                                        _ctx.bankTransactionPanel = false;
                                    }
                        }, [
                          _createVNode(_component_v_btn, {
                            rounded: "",
                            size: "x-small"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(props.item.selected ? "Retirer" : "Ajouter"), 1)
                            ]),
                            _: 2
                          }, 1024)
                        ], 8, _hoisted_32)
                      ])
                    ]),
                    _: 1
                  }, 8, ["headers", "items", "page", "sort-by", "sort-desc", "items-per-page", "items-length"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_card_actions, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_btn, {
                rounded: "",
                onClick: _cache[25] || (_cache[25] = ($event: any) => (_ctx.bankTransactionPanel = false)),
                size: "small"
              }, {
                default: _withCtx(() => _cache[55] || (_cache[55] = [
                  _createTextVNode(" Précédent ")
                ])),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 512), [
        [_vShow, _ctx.bankTransactionPanel]
      ]),
      (_ctx.openChat)
        ? (_openBlock(), _createBlock(_component_Chat, {
            key: 0,
            id: _ctx.chatId,
            inShowMessage: _ctx.open_chat,
            chatTitle: 'Ligne bancaire',
            chatSubtitle: _ctx.getChatSubTitle(),
            showSmartChat: _ctx.wishStatus !== 'DENIED',
            onMessageSent: _cache[26] || (_cache[26] = ($event: any) => (_ctx.onMessageSent($event))),
            onShowMessageChanged: _cache[27] || (_cache[27] = ($event: any) => (_ctx.onShowMessageChanged($event)))
          }, null, 8, ["id", "inShowMessage", "chatSubtitle", "showSmartChat"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}